"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Html;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _GenericStore = require("../store/GenericStore");

var _reactI18next = require("react-i18next");

var _Component = _interopRequireDefault(require("../../render/Component"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%'
    },
    card: {
      width: '100%',
      padding: '10px 0'
    },
    title: {
      width: '100%',
      display: 'flex',
      fontSize: '20px'
    },
    number: {
      flexShrink: 0,
      paddingRight: '2px'
    },
    titleText: {
      flexShrink: 1
    },
    component: {
      padding: '10px 0'
    },
    required: {
      color: 'red'
    }
  };
});

function Html(props) {
  var _props$block = props.block,
      html = _props$block.html,
      title = _props$block.title,
      style = _props$block.style,
      blockPath = _props$block.path,
      parentPath = props.parentPath,
      number = props.number;
  var classes = useStyles();

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var styleToApply = {};

  if (style) {
    try {
      styleToApply = JSON.parse(style);
    } catch (e) {
      console.log('error parsing style in html component', e);
    }
  }

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    style: styleToApply,
    dangerouslySetInnerHTML: {
      __html: html
    },
    className: "ctnHtml"
  }));
}